import {useContext, useEffect, useState} from 'react'
import {AdminContext} from '../../../../../../context/AdminContext'
import React from 'react'

const UploadLoader = () => {
  const {postCodeMessage, postCodeProgress, setPostCodeMessage} = useContext(AdminContext)
  return (
    <React.Fragment>
      {postCodeMessage ? (
        <div
          className={`alert ${postCodeMessage.isSuccess ? 'alert-info' : 'alert-danger'} w-25 m-auto`}
          role='alert'
        >
          <div className='d-flex'>
            <div
              className='p-2 text-center'
              style={{
                width: '95%',
              }}
            >
              {postCodeMessage.message}
            </div>
            <div
              className='ml-auto p-2'
              style={{
                cursor: 'pointer',
                transition: 'cursor 0.3s',
              }}
              onClick={() => {
                setPostCodeMessage(null)
              }}
            >
              <span aria-hidden='true'>&times;</span>
            </div>
          </div>
        </div>
      ) : (
        <div className='d-flex flex-column w-100 mb-12'>
          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar progress-bar-striped progress-bar-animated `}
              role='progressbar'
              style={{width: postCodeProgress + '%'}}
            ></div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}
export {UploadLoader}
